type DetailPlaceholderProps = {
    description: string
}

const DetailPlaceholder = (props: DetailPlaceholderProps) => {
    const { description } = props

    return (
        <div className="h-full flex flex-col items-center justify-center">
            <p className="text-small text-grey-dark">{description}</p>
        </div>
    )
}

export default DetailPlaceholder
